<template>
     <div class="col-group">
            <TaxinummerLink date="Januari 2017" nummer="67" />
            <TaxinummerLink date="Februari 2017" nummer="68" />
            <TaxinummerLink  date="Maart 2017" nummer="69"/>
            <TaxinummerLink date="April 2017" nummer="70" />
            <TaxinummerLink date="Mei 2017" nummer="71" />
            <TaxinummerLink date="Juni 2017 " nummer="72" />
            <TaxinummerLink date="Juli-Augustus 2017 " nummer="73" />
            <TaxinummerLink date="September 2017 " nummer="74" />
            <TaxinummerLink date="Oktober 2017" nummer="75" />
            <TaxinummerLink date="November 2017" nummer="76" />
            <TaxinummerLink date="December 2017" nummer="77" />
     </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
    name: 'magazine-2016',
    components: {
        'TaxinummerLink': TaxinummerLink,
    }
}
</script>
